'use client';
import { isEmpty } from '@witmetrics/utils/misc';
import { mapToId, sortByUpdatedAt } from '@witmetrics/utils/arrays';
import { useLeadProjects } from '@witmetrics/data-store';
import { useAppState } from '@/providers/AppStateProvider';
import { Tab } from '@/components/TabsBlock';
import Section from '@/overlays/PatientOverlay/Section';
import SectionTitle from '@/overlays/PatientOverlay/SectionTitle';
import EmptyMessage from '@/overlays/PatientOverlay/EmptyMessage';
import ProjectsList from '@/components/ProjectsList';
import { classes } from './utils';

export type CasesTabProps = {
  isFetchingData: boolean;
  name: string;
  label: string;
};

export default function CasesTab({
  isFetchingData,
  name,
  label,
}: CasesTabProps) {
  const { activeLeadId } = useAppState();
  const projects = useLeadProjects(activeLeadId);

  return (
    <Tab className={classes.tab} name={name} label={label}>
      <Section>
        <SectionTitle
          title="Cases"
          newLabel="Start case"
          // onAddNew={() => null /* TODO */}
        />
        {isEmpty(projects) ? (
          <EmptyMessage>No cases for current patient</EmptyMessage>
        ) : (
          <ProjectsList
            isFetchingData={isFetchingData}
            className={classes.list}
            projectIds={mapToId(sortByUpdatedAt(projects))}
          />
        )}
      </Section>
    </Tab>
  );
}
